<template>
	<v-container class="mt-4 px-5" fluid>
		<span v-if="verTicketsJefe">
			<TicketAreaEspecial/>
		</span>

		<span v-if="verTicketsAuxiliar">
			<TicketAuxiEspecial/>
		</span>
	</v-container>
</template>
<script>
  import axios from 'axios';
  var moment = require('moment');
  moment.locale('es');

  import {mapGetters, mapActions} from 'vuex'
  import TicketAreaEspecial from '@/views/tickets/operaciones/TicketAreaEspecial'
  import TicketAuxiEspecial from '@/views/tickets/operaciones/TicketAuxiEspecial'
  import { esJefeTickets } from '@/utils/permisosTicketsValeria'

  export default {
  	components:{
  		TicketAreaEspecial,
			TicketAuxiEspecial
  	},

    data: () => ({

    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioERPERP']),
      verTicketsJefe () {
        return esJefeTickets(this.getdatosUsuarioERPERP)
      },
      verTicketsAuxiliar () {
        if (this.verTicketsJefe) return false
        return !!(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.cargo == 'Auxiliar')
      },
    },

    created ( ){
      console.log( this.getdatosUsuarioERPERP )
    }

  }
</script>
